module.exports = __webpack_public_path__ + "static/media/event-private.5b4f6910.jpg";